import React from 'react';
import { MASTER_TEST_UNIT_EDIT_FIELDS } from './constant';
import { useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import ModalComponent from '../../../../../components/common-components/modal/ModalComponent';
import Icons from '../../../../../components/icons/Icons';
import Button from '../../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../../components/common-components/button/Constants';
import Input from '../../../../../components/common-components/input/Input';
import { getValidationSchema } from '../../../../../libs/formsUtils';
import { updateMasterTestUnit } from './MasterTestUnitSaga';

function MasterEditTestUnitModel({data, open, close, }) {    
    const dispatch = useDispatch();
    const fields = [
        {
            fieldName: MASTER_TEST_UNIT_EDIT_FIELDS.TEST_NAME,
            isRequired: true,
        },
        {
            fieldName: MASTER_TEST_UNIT_EDIT_FIELDS.UNIT,
            isRequired: true,
        },
        {
            fieldName: MASTER_TEST_UNIT_EDIT_FIELDS.MAIN_TEST,
            isRequired: true,
        },
    ];

    const validationSchema = getValidationSchema(fields)

    return (
        <Formik
            initialValues={
                {
                    [MASTER_TEST_UNIT_EDIT_FIELDS.TEST_NAME]: data?.testName,
                    [MASTER_TEST_UNIT_EDIT_FIELDS.UNIT]: data?.unit,
                    [MASTER_TEST_UNIT_EDIT_FIELDS.MAIN_TEST]: data?.mainTest,
                }
            }
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values) => {
                const payload = {
                    apiPayload: {
                        ...values,
                    },
                    id: data?.uuid,
                    closeEditModal: close,
                };                
                try {
                    dispatch(updateMasterTestUnit(payload));
                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {({ submitForm, isSubmitting, handleReset, values, setFieldValue, handleSubmit }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <ModalComponent
                            open={open}
                            title={'Edit Test Unit'}
                            close={() => {
                                close();
                            }}
                            icon={<Icons iconName="closeIcon" />}
                            footerButton={
                                <Button
                                    type="submit"
                                    variant={BUTTON_VARIANTS.CONTAINED}
                                    customBtnClass="text-met-primary"
                                >
                                    Update
                                </Button>
                            }
                            customClasses="w-[60%] overflow-visible"
                            enableReinitialize
                            hideOverflow={true}
                        >
                            <div className="flex flex-col">
                                <div className="w-full flex justify-between">
                                    <div className="w-[45%]">
                                        <Input
                                            label="Test Name"
                                            isRequired={true}
                                            placeholder="Enter Test Name"
                                            name={MASTER_TEST_UNIT_EDIT_FIELDS.TEST_NAME}
                                            value={values[MASTER_TEST_UNIT_EDIT_FIELDS.TEST_NAME]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_TEST_UNIT_EDIT_FIELDS.TEST_NAME, e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="w-[45%]">
                                        <Input
                                            label="Unit"
                                            isRequired={true}
                                            placeholder="Enter Unit"
                                            name={MASTER_TEST_UNIT_EDIT_FIELDS.UNIT}
                                            value={values[MASTER_TEST_UNIT_EDIT_FIELDS.UNIT]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_TEST_UNIT_EDIT_FIELDS.UNIT, e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex justify-between mt-[20px]">
                                    <div className="w-[45%]">
                                        <Input
                                            label="Main Test"
                                            isRequired={true}
                                            placeholder="Enter Main Test"
                                            name={MASTER_TEST_UNIT_EDIT_FIELDS.MAIN_TEST}
                                            value={values[MASTER_TEST_UNIT_EDIT_FIELDS.MAIN_TEST]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_TEST_UNIT_EDIT_FIELDS.MAIN_TEST, e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </ModalComponent>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default MasterEditTestUnitModel; 